var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "video-course-item clickable" }, [
    _c(
      "div",
      {
        staticClass: "card-title video-course-item__title typography--body-1",
        attrs: { title: _vm.course.title }
      },
      [
        _vm._v(
          "\n    " +
            _vm._s(_vm.course.title + " (" + _vm.course.id + ")") +
            "\n  "
        )
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "typography--body-2" }, [
      _c(
        "small",
        {
          staticClass:
            "text-muted typography--caption typography--color-secondary"
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm.getGradeLabel(_vm.course)) +
              "\n      " +
              _vm._s(_vm.getSubjectLabel(_vm.course)) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _vm.course.domain
        ? _c(
            "small",
            {
              staticClass:
                "text-muted typography--caption typography--color-secondary"
            },
            [
              _c("span", { staticClass: "ml-1 mr-1" }, [_vm._v("|")]),
              _vm._v(
                "\n      " +
                  _vm._s("영역: " + _vm.course.domain.name) +
                  "\n    "
              )
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "typography--body-2" }, [
      _c(
        "small",
        {
          staticClass:
            "text-muted typography--caption typography--color-secondary"
        },
        [_vm._v("\n      " + _vm._s(_vm.getUnitName(_vm.course)) + "\n    ")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "typography--body-2" }, [
      _c(
        "small",
        {
          staticClass:
            "text-muted typography--caption typography--color-secondary"
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t("video_lectures.video_course.lecture_count", {
                  count: _vm.course.lecture_count
                })
              ) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "small",
        {
          staticClass:
            "text-muted typography--caption typography--color-secondary"
        },
        [
          _c("span", { staticClass: "ml-1 mr-1" }, [_vm._v("|")]),
          _vm._v(" "),
          _vm.course.share_level === "1"
            ? _c("span", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("common.card.share_level.public")) +
                    "\n      "
                )
              ])
            : _c("span", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("common.card.share_level.private")) +
                    "\n      "
                )
              ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3afacfe0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3afacfe0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/video-courses/components/VideoCourseItem.vue
// module id = 0OPP
// module chunks = 1